import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["roleCheckbox", "roleCheckGroupLink", "roleCheckAllLink",
        "roleUncheckGroupLink", "roleUncheckAllLink"]

    connect() {
        this.displayRoleLinks()

        this.roleCheckboxTargets.forEach(checkbox => {
            checkbox.addEventListener('change', this.displayRoleLinks.bind(this));
        });
        this.roleCheckGroupLinkTargets.forEach(link => {
            link.addEventListener('click', this.toggleRoleCheckboxes.bind(this));
        });
        this.roleUncheckGroupLinkTargets.forEach(link => {
            link.addEventListener('click', this.toggleRoleCheckboxes.bind(this));
        });

        this.roleCheckAllLinkTarget.addEventListener('click', this.toggleRoleCheckboxes.bind(this));
        this.roleUncheckAllLinkTarget.addEventListener('click', this.toggleRoleCheckboxes.bind(this));
    }

    disconnect() {
        this.roleCheckboxTargets.forEach(checkbox => {
            checkbox.removeEventListener('change', this.displayRoleLinks.bind(this));
        });
        this.roleCheckGroupLinkTargets.forEach(link => {
            link.removeEventListener('click', this.toggleRoleCheckboxes.bind(this));
        });
        this.roleUncheckGroupLinkTargets.forEach(link => {
            link.removeEventListener('click', this.toggleRoleCheckboxes.bind(this));
        });

        this.roleCheckAllLinkTarget.removeEventListener('click', this.toggleRoleCheckboxes.bind(this));
        this.roleUncheckAllLinkTarget.removeEventListener('click', this.toggleRoleCheckboxes.bind(this));
    }

    displayRoleLinks() {
        const allChecked = this.roleCheckboxTargets.every(t => t.checked)

        if (allChecked) {
            this.roleCheckAllLinkTarget.classList.add('d-none')
            this.roleUncheckAllLinkTarget.classList.remove('d-none')
        } else {
            this.roleCheckAllLinkTarget.classList.remove('d-none')
            this.roleUncheckAllLinkTarget.classList.add('d-none')
        }

        this.roleCheckGroupLinkTargets.forEach((groupLink) => {
            const groupCheckboxesChecked = this.roleCheckboxTargets
                .filter(checkbox => checkbox.dataset.group === groupLink.dataset.group)
                .every(checkbox => checkbox.checked)
            const groupUncheckLink = this.roleUncheckGroupLinkTargets
                .find(link => link.dataset.group === groupLink.dataset.group)
            if (groupCheckboxesChecked) {
                groupLink.classList.add('d-none')
                groupUncheckLink.classList.remove('d-none')
            } else {
                groupLink.classList.remove('d-none')
                groupUncheckLink.classList.add('d-none')
            }
        })
    }

    toggleRoleCheckboxes() {
        const checkboxes = this.roleCheckboxTargets
        const currentTarget = event.currentTarget
        if (this.roleCheckAllLinkTarget === currentTarget) {
            checkboxes.forEach(checkbox => {
                    checkbox.checked = true
                }
            )
        }
        if (this.roleUncheckAllLinkTarget === currentTarget) {
            checkboxes.forEach(checkbox => {
                    checkbox.checked = false
                }
            )
        }

        if (this.roleCheckGroupLinkTargets.includes(currentTarget)) {
            this.roleCheckboxTargets.filter(checkbox => checkbox.dataset.group === currentTarget.dataset.group)
                .forEach(checkbox => {
                    checkbox.checked = true
                })
        }
        if (this.roleUncheckGroupLinkTargets.includes(currentTarget)) {
            this.roleCheckboxTargets.filter(checkbox => checkbox.dataset.group === currentTarget.dataset.group)
                .forEach(checkbox => {
                    checkbox.checked = false
                })
        }
        this.displayRoleLinks()
    }
}
